window.addEventListener("resize", ajustarSticky);
window.addEventListener("load", ajustarSticky);

function ajustarSticky() {
  const contenedor1 = document.querySelector(".announcement-bar-section");
  const contenedor2 = document.querySelector(".barra-ayuda-top");
  const contenedor3 = document.querySelector(".shopify-section-header-sticky");

  // Obtener la altura del contenedor1
  const alturaContenedor1 = contenedor1.offsetHeight;

  // Ajustar el top de los otros contenedores en función de la altura de los anteriores
  contenedor2.style.top = `${alturaContenedor1}px`;
  contenedor3.style.top = `${alturaContenedor1 + contenedor2.offsetHeight}px`;
}

document
  .querySelector(".header-search-bar")
  ?.addEventListener("click", () => {
    setTimeout(() => {
      document.querySelector('.search-modal input[type="search"]')?.focus();
    }, 100); // por si hay animación
  });